import { defineComponent as d, computed as c, openBlock as t, createElementBlock as n, unref as i, toDisplayString as v, createBlock as l, withCtx as u, resolveDynamicComponent as b } from "vue";
import { ElIcon as f } from "./index538.js";
import { paginationPrevEmits as k, paginationPrevProps as g } from "./index744.js";
import { useLocale as P } from "./index597.js";
const y = ["disabled", "aria-label", "aria-disabled"], C = { key: 0 };
var T = /* @__PURE__ */ d({
  name: "ElPaginationPrev",
  __name: "prev",
  props: g,
  emits: k,
  setup(p) {
    const a = p, { t: s } = P(), o = c(
      () => a.disabled || a.currentPage <= 1
    );
    return (e, r) => (t(), n("button", {
      type: "button",
      class: "btn-prev",
      disabled: o.value,
      "aria-label": e.prevText || i(s)("el.pagination.prev"),
      "aria-disabled": o.value,
      onClick: r[0] || (r[0] = (m) => e.$emit("click", m))
    }, [
      e.prevText ? (t(), n(
        "span",
        C,
        v(e.prevText),
        1
        /* TEXT */
      )) : (t(), l(i(f), { key: 1 }, {
        default: u(() => [
          (t(), l(b(e.prevIcon)))
        ]),
        _: 1
        /* STABLE */
      }))
    ], 8, y));
  }
});
export {
  T as default
};
